<template>
    <div class="boxes page-node-show">
        <div class="box">
            <div class="box-heading border-bottom" style="position: relative;">
                <h5>生日提醒日志</h5>
            </div>
            <div class="threads-items mb-2">
                <ul class="list-group list-group-flush">
                    <li
                        class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                    >
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                昵称
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-40">
                            <div class="text-gray">
                                生日
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-40">
                            <div class="text-gray">
                                提醒日期
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                发送结果
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                发送时间
                            </div>
                        </div>
                    </li>

                    <li
                        class="list-group-item d-md-flex d-block align-items-center justify-content-between cursor-pointer"
                        v-for="item in logs"
                        :key="item.id"
                    >
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                {{ item.reminder_config.nick_name }}
                                <small v-if="item.reminder_config.is_self">（我自己）</small>
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-40">
                            <div class="text-gray">
                                {{ item.reminder_config.birthday }}
                                <small v-if="item.reminder_config.calendar_type_text">（{{ item.reminder_config.calendar_type_text }}）</small>
                                <small v-else>（{{ item.reminder_config.calendar_type == 0 ? '农历' : '阳历' }}）</small>
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-40">
                            <div class="text-gray">
                                阳历：{{ item.reminder_config.next_solar_calendar }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                {{ item.status == 1 ? '成功' : '失败' }}
                            </div>
                        </div>
                        <div class="d-flex align-items-center w-20">
                            <div class="text-gray">
                                {{ item.time_formatting }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';
    import Paginator from '$components/paginator'

    export default {
        name: 'birthday-reminder',
        components: {
            Paginator
        },
        data() {
            return {
                logs: [],
            }
        },
        created () {
            this.getConfigs();
        },
        methods: {
            getConfigs() {
                this.$http
                .get(`/birthday-reminder/logs`)
                .then((res) => {
                    this.logs = res.data;
                });
            },
        }
    }
</script>
